import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const base = config.jmw_market_env + "app-search/search/";
export default {
    optionChainTool: config.jmw + base + "optionchain",
    genTrending: config.jmw + base + "trending-and-recent",
    saveTrending: config.jmw + base + "trending",
    genSearch: config.jmw + base,
    eqSearch: config.jmw + base + "equity",
    fuSearch: config.jmw + base + "futures",
    opSearch: config.jmw + base + "options",
    cuSearch: config.jmw + base + "currencies",
    comSearch: config.jmw + base + "commodities",
    comfut: config.jmw + base + "com-fut",
    comopt: config.jmw + base + "com-opt",
    etfsSearch: config.jmw + base + "etfs",
    indSearch: config.jmw + base + "indices",
    pmSearch: config.jmw + base + "primary-markets",
    ncdsSearch: config.jmw + base + "ncds",
    mfSearch: config.jmw + base + "mutualfunds",
    sgbSearch: config.jmw + base + "sgb",
    corpFdSearch: config.jmw + base + "corpFd",
};
